import { blue, grey, red } from "@mui/material/colors";

type NameMap = {
  [key: string]: string;
};
export const BANK_TYPE = new Map([
  ["Amex", "Amex Membership Rewards"],
  ["Bilt", "Bilt Rewards"],
  ["Capital One", "Capital One Miles"],
  ["Chase", "Chase Ultimate Rewards"],
  ["Citi", "Citi ThankYou Points"],
  ["Wells Fargo", "Wells Fargo Rewards"],
]);

export const BANK_TYPE2 = new Map([
  ["American Exp Membership Rewards", "amex"],
  ["Bilt Rewards", "bilt"],
  ["Capital One Miles", "capital one"],
  ["Chase Ultimate Rewards", "chase"],
  ["Citi ThankYou Points", "citi"],
  ["Wells Fargo Rewards", "wells fargo"],
]);

export const REVERSE_BANK_TYPE2 = new Map([
  ["amex", "American Exp Membership Rewards"],
  ["bilt", "Bilt Rewards"],
  ["capital one", "Capital One Miles"],
  ["chase", "Chase Ultimate Rewards"],
  ["citi", "Citi ThankYou Points"],
  ["wells fargo", "Wells Fargo Rewards"],
]);

export const SHOW_PROGRAM_NAME_MAP = new Map([
  ["AA", "American Airlines AAdvantage"],
  ["AC", "Air Canada Aeroplan"],
  ["AM", "Aeromexico Club Premier"],
  ["AS", "Alaska Airlines Mileage Plan"],
  ["AV", "Avianca LifeMiles"],
  ["B6", "JetBlue True Blue"],
  ["BA", "British Airways Executive Club"],
  ["CM", "Copa ConnectMiles"],
  ["LH", "Lufthansa Miles & More"],
  ["G3", "GOL Smiles"],
  ["AD", "Azul TudoAzul"],
  ["DL", "Delta SkyMiles"],
  ["EK", "Emirates Skywards"],
  ["EY", "Etihad Guest"],
  ["IB", "Iberia Avios"],
  ["KL", "Air France/KLM Flying Blue"],
  ["NK", "Spirit"],
  ["QF", "Qantas Frequent Flyer"],
  ["SQ", "Singapore KrisFlyer"],
  ["SK", "SAS EuroBonus"],
  ["TP", "TAP Air Portugal Miles&Go"],
  ["TK", "Turkish Miles & Smiles"],
  ["UA", "United MileagePlus"],
  ["VA", "Virgin Australia Velocity"],
  ["VS", "Virgin Atlantic Flying Club"],
]);

export const SHOW_PANORAMA_PROGRAM_NAME_MAP = new Map([
  ["AA", "American Airlines AAdvantage"],
  ["AC", "Air Canada Aeroplan"],
  ["AM", "Aeromexico Club Premier"],
  ["AS", "Alaska Airlines Mileage Plan"],
  ["AV", "Avianca LifeMiles"],
  ["B6", "JetBlue True Blue"],
  ["CM", "Copa ConnectMiles"],
  ["G3", "GOL Smiles"],
  ["AD", "Azul TudoAzul"],
  // ["CX", "Cathay Pacific Asia Miles"],
  ["DL", "Delta SkyMiles"],
  ["EK", "Emirates Skywards"],
  ["EY", "Etihad Guest"],
  ["BA", "British Airways Executive Club"],
  ["IB", "Iberia Avios"],
  ["KL", "Air France/KLM Flying Blue"],
  ["NK", "Spirit"],
  ["QF", "Qantas Frequent Flyer"],
  ["SQ", "Singapore KrisFlyer"],
  ["SK", "SAS EuroBonus"],
  ["TP", "TAP Air Portugal Miles&Go"],
  ["TK", "Turkish Miles & Smiles"],
  ["UA", "United MileagePlus"],
  ["VA", "Virgin Australia Velocity"],
  ["VS", "Virgin Atlantic Flying Club"],
]);

export const PROGRAM_NAME_MAP = new Map([
  ["AA", "American Airlines AAdvantage"],
  ["AC", "Air Canada Aeroplan"],
  ["AM", "Aeromexico Club Premier"],
  ["AS", "Alaska Airlines Mileage Plan"],
  ["AV", "Avianca LifeMiles"],
  ["B6", "JetBlue True Blue"],
  ["CM", "Copa ConnectMiles"],
  ["CX", "Cathay Pacific Asia Miles"],
  ["G3", "GOL Smiles"],
  ["AD", "Azul TudoAzul"],
  ["DL", "Delta SkyMiles"],
  ["EK", "Emirates Skywards"],
  ["EY", "Etihad Guest"],
  ["BA", "British Airways Executive Club"],
  ["IB", "Iberia Avios"],
  ["KL", "Air France/KLM Flying Blue"],
  ["NK", "Spirit"],
  ["QF", "Qantas Frequent Flyer"],
  ["SQ", "Singapore KrisFlyer"],
  ["SK", "SAS EuroBonus"],
  ["TP", "TAP Air Portugal Miles&Go"],
  ["TK", "Turkish Miles & Smiles"],
  ["UA", "United MileagePlus"],
  ["VA", "Virgin Australia Velocity"],
  ["VS", "Virgin Atlantic Flying Club"],
]);

// Program that can be voted
export const VOTE_PROGRAM_NAME_MAP = new Map([
  ["AA", "American Airlines AAdvantage"],
  ["AC", "Air Canada Aeroplan"],
  ["AM", "Aeromexico Club Premier"],
  ["AS", "Alaska Airlines Mileage Plan"],
  ["AV", "Avianca LifeMiles"],
  // ["BA", "British Airways Executive Club"],
  ["DL", "Delta SkyMiles"],
  ["EK", "Emirates Skywards"],
  ["EY", "Etihad Guest"],
  ["KL", "Air France/KLM Flying Blue"],
  ["IB", "Iberia Avios"],
  // ["CM", "Copa ConnectMiles"],
  ["G3", "GOL Smiles"],
  ["AD", "Azul TudoAzul"],
  ["SQ", "Singapore KrisFlyer"],
  ["QF", "Qantas Frequent Flyer"],
  ["SK", "SAS EuroBonus"],
  ["UA", "United MileagePlus"],
  ["VA", "Virgin Australia Velocity"],
  ["VS", "Virgin Atlantic Flying Club"],
  ["TK", "Turkish Miles & Smiles"],
  // ["F9", "Frontier"],
  ["B6", "JetBlue True Blue"],
  ["NK", "Spirit"],
  ["TP", "TAP Air Portugal Miles&Go"],
]);

// Program that can be refreshed
export const REFRESH_PROGRAM_NAME_MAP = new Map([
  ["AA", "American Airlines AAdvantage"],
  ["AC", "Air Canada Aeroplan"],
  ["AM", "Aeromexico Club Premier"],
  ["AS", "Alaska Airlines Mileage Plan"],
  ["AV", "Avianca LifeMiles"],
  // ["BA", "British Airways Executive Club"],
  ["DL", "Delta SkyMiles"],
  ["EK", "Emirates Skywards"],
  ["EY", "Etihad Guest"],
  ["KL", "Air France/KLM Flying Blue"],
  // ["IB", "Iberia Avios"],
  // ["CM", "Copa ConnectMiles"],
  // ["G3", "GOL Smiles"],
  // ["AD", "Azul TudoAzul"],
  ["QF", "Qantas Frequent Flyer"],
  ["SK", "SAS EuroBonus"],
  ["UA", "United MileagePlus"],
  ["VA", "Virgin Australia Velocity"],
  ["VS", "Virgin Atlantic Flying Club"],
  ["TK", "Turkish Miles & Smiles"],
  // ["SQ", "Singapore KrisFlyer"],
  // ["F9", "Frontier"],
  ["B6", "JetBlue True Blue"],
  ["NK", "Spirit"],
  ["TP", "TAP Air Portugal Miles&Go"],
]);

export const ROUTE_PROGRAM_NAME_MAP = new Map([
  ["AA", "American Airlines AAdvantage"],
  ["AC", "Air Canada Aeroplan"],
  ["AM", "Aeromexico Club Premier"],
  ["AS", "Alaska Airlines Mileage Plan"],
  ["AV", "Avianca LifeMiles"],
  ["DL", "Delta SkyMiles"],
  ["EK", "Emirates Skywards"],
  ["EY", "Etihad Guest"],
  ["KL", "Air France/KLM Flying Blue"],
  ["IB", "Iberia Avios"],
  ["BA", "British Airways Executive Club"],
  ["CX", "Cathay Pacific Asia Miles"],
  // ["CM", "Copa ConnectMiles"],
  ["G3", "GOL Smiles"],
  ["AD", "Azul TudoAzul"],
  ["QF", "Qantas Frequent Flyer"],
  ["SQ", "Singapore KrisFlyer"],
  ["SK", "SAS EuroBonus"],
  ["UA", "United MileagePlus"],
  ["VA", "Virgin Australia Velocity"],
  ["VS", "Virgin Atlantic Flying Club"],
  ["TK", "Turkish Miles & Smiles"],
  // ["F9", "Frontier"],
  ["B6", "JetBlue True Blue"],
  ["NK", "Spirit"],
  ["TP", "TAP Air Portugal Miles&Go"],
]);

export const SORTED_ROUTE_PROGRAM_NAME_MAP = new Map(
  Array.from(ROUTE_PROGRAM_NAME_MAP).sort((a, b) => a[1].localeCompare(b[1]))
);

// Sort map by value
export const SORTED_PROGRAM_NAME_MAP = new Map(
  Array.from(PROGRAM_NAME_MAP).sort((a, b) => a[1].localeCompare(b[1]))
);

export const PROGRAM_IMG: NameMap = {
  AA: "https://img.awardtool.com/card_AA.png",
  BA: "https://img.awardtool.com/card_BA_v3.jpg",
  AS: "https://img.awardtool.com/card_AS_2.png",
  DL: "https://img.awardtool.com/card_DL.png",
  AM: "https://img.awardtool.com/card_AM.png",
  KL: "https://img.awardtool.com/card_KL.png",
  AC: "https://img.awardtool.com/card_AC.png",
  CX: "https://img.awardtool.com/card_CX.png",
  SK: "https://img.awardtool.com/card_SK.png",
  VA: "https://img.awardtool.com/card_VA.png",
  QF: "https://img.awardtool.com/card_QF.png",
  UA: "https://img.awardtool.com/card_UA.png",
  B6: "https://img.awardtool.com/card_B6.png",
  EY: "https://img.awardtool.com/card_EY.png",
  VS: "https://img.awardtool.com/card_VS.png",
  EK: "https://img.awardtool.com/card_EK_V2.png",
  TK: "https://img.awardtool.com/card_TK.png",
  TP: "https://img.awardtool.com/card_TP.png",
  IB: "https://img.awardtool.com/card_IB.png",
  CM: "https://img.awardtool.com/card_CM.png",
  AD: "https://img.awardtool.com/card_AD.png",
  AV: "https://img.awardtool.com/card_AV.png",
  NK: "https://img.awardtool.com/card_NK_2.png",
  SQ: "https://img.awardtool.com/card_SQ_3.png",
  G3: "https://img.awardtool.com/card_G3.png",
};

export const BANK_IMG: NameMap = {
  bilt: "https://img.awardtool.com/bilt_1x.png",
  chase: "https://img.awardtool.com/chase_1x.png",
  amex: "https://img.awardtool.com/amex_1x.png",
  "capital one": "https://img.awardtool.com/capital_one_1x.png",
  citi: "https://img.awardtool.com/citi_1x.png",
  marriott: "https://img.awardtool.com/marriott_1x.png",
  "wells fargo": "https://img.awardtool.com/wells_fargo_1x_v3.png",
};

export const BANK_COLOR: NameMap = {
  bilt: "#000",
  chase: "#1565c0",
  amex: "#039be5",
  "capital one": "#b71c1c",
  citi: "#43a047",
  "wells fargo": "red",
  marriott: blue[500],
};

export const tranfer_bank_to_program = new Map([
  [
    "Capital One Miles Rewards",
    ["AC", "TP", "CX", "TK", "AM", "AV", "BA", "SQ", "EK", "EY", "KL", "QF", "VS"],
  ],
  ["Chase Ultimate Rewards", ["AC", "B6", "BA", "EK", "KL", "UA", "VS", "IB", "SQ"]],
  [
    "American Exp Membership Rewards",
    ["AC", "AM", "CX", "AV", "B6", "BA", "DL", "EK", "EY", "KL", "QF", "VS", "IB", "SQ"],
  ],
  ["Bilt Rewards", ["AC", "AS", "CX", "BA", "TK", "EK", "KL", "UA", "VS", "IB"]],
  [
    "Citi Thank You Points",
    ["AM", "AV", "CX", "TK", "BA", "B6", "EK", "EY", "KL", "QF", "VS", "SQ"],
  ],
  ["Wells Fargo Rewards", ["AV", "KL", "IB", "BA"]],
]);

export const BANK_NAME_MAP: NameMap = {
  bilt: "Bilt Rewards",
  chase: "Chase Ultimate Rewards",
  amex: "American Exp Membership Rewards",
  citi: "Citi Thank You Points",
  "capital one": "Capital One Miles Rewards",
  "wells fargo": "Wells Fargo Rewards",
  // marriott: "Marriott Bonvoy Points",
  // brex: "Brex Rewards",
};

// 用于routes drop-menu
export const BANK_ALIAS_NAME_MAP: NameMap = {
  bilt: "bilt",
  chase: "chase",
  amex: "amex",
  citi: "citi",
  "capital one": "cap one",
  "wells fargo": "w fargo",
};

export const BANK_GUIDE_MAP: NameMap = {
  bilt: "/guides/bilttransfer",
  chase: "/guides/chasetransfer",
  amex: "/guides/amextransfer",
  citi: "/guides/cititransfer",
  "capital one": "/guides/capitalonetransfer",
  // marriott: "Marriott Bonvoy Points",
  // brex: "Brex Rewards",
};

export const TRANSFER_MAP: NameMap = {
  "capital one": "https://verified.capitalone.com/auth/signin",
  amex: "https://global.americanexpress.com/rewards/transfer",
  chase: "https://secure04ea.chase.com/web/auth/#/logon/logon/chaseOnline",
  bilt: "https://www.biltrewards.com/",
  citi: "https://www.thankyou.com/partnerProgramsListing.html",
  marriott: "https://www.marriott.com/loyalty/redeem/travel/points-to-miles.mi",
  "wells fargo": "https://www.wellsfargo.com/rewards/",
};

export const BUY_POINT_LINKS: NameMap = {
  av: "https://www.kqzyfj.com/click-101122498-12278854",
  as: "https://www.dpbolvw.net/click-101122498-12837751",
  ac: "https://www.aircanada.com/ca/en/aco/home/aeroplan/your-aeroplan.html",
  ua: "https://www.jdoqocy.com/click-101122498-12837764",
  b6: "https://www.dpbolvw.net/click-101122498-11350054",
  f9: "https://buy.points.com/marketing/frontier/",
  aa: "https://www.aa.com/aadvantage-program/buy-gift-transfer/en_US/home/buy",
  dl: "https://www.delta.com/buygftxfer/displayBuyMiles.action",
  tk: "https://www.turkishairlines.com/en-int/miles-and-smiles/program-content/purchasing-miles",
  cm: "https://www.copaair.com/en-us/connectmiles/miles/transactions-with-miles/",
  ad: "https://www.tudoazul.voeazul.com.br/",
  vs: "https://flywith.virginatlantic.com/gb/en/flying-club/earn-points/buy-points.html",
  ib: "https://pgt.shopping.ba.com/?utm_source=AboutAvios&utm_medium=BA&utm_campaign=default&utm_content=Purchasing",
  sk: "https://www.saseurobonusshop.com/en/account/buy-and-transfer-points",
  tp: "https://www.flytap.com/en-us/client-area/buy-miles?cardId=undefined",
  ek: "https://www.emirates.com/english/skywards/do-more-with-your-miles/",
  kl: "https://www.anrdoezrs.net/click-101122498-11824918",
  va: "https://buy.points.com/marketing/vff/landing_page/",
  qf: "https://www.qantas.com/us/en/frequent-flyer/my-account/points-activity/top-up-points.html",
  nk: "https://www.anrdoezrs.net/click-101122498-11939371",
  ey: "https://www.dpbolvw.net/click-101122498-10887320",
  ba: "https://www.kqzyfj.com/click-101122498-12748265",
  sq: "https://www.singaporeair.com/en_UK/us/ppsclub-krisflyer/use-miles/redeem-miles/",
  cx: "https://www.cathaypacific.com/cx/en_HK/membership/my-account/miles-and-points/manage-miles/top-up-asia-miles.html",
  lh: "https://account.miles-and-more.com/partners/de/en/login.html",
};

export const BANK_TRANSFER_LINK: NameMap = {
  bilt: "https://www.biltrewards.com/rewards/bilt-for-you",
  "capital one": "https://myaccounts.capitalone.com/Card/rewardsTransferPartners",
  chase: "https://ultimaterewardspoints.chase.com/home?source=vanity",
  citi: "https://www.thankyou.com/partnerProgramsListing.htm",
  amex: "https://global.americanexpress.com/rewards/transfer",
  "wells fargo": "https://www.wellsfargo.com/rewards/",
};

export const PROGRAM_BUY_LINK: NameMap = {
  aa: "https://www.aa.com/booking/search?locale=en_US&pax={data.passengers}&adult={data.passengers}&type=OneWay&searchType=Award&cabin=&carriers=ALL&slices=%5B%7B%22orig%22:%22{data.departure_airport}%22,%22origNearby%22:false,%22dest%22:%22{data.arrival_airport}%22,%22destNearby%22:false,%22date%22:%22{data.departure_date}%22%7D%5D&maxAwardSegmentAllowed=4",
  ac: "https://www.aircanada.com/aeroplan/redeem/availability/outbound?org0={data.departure_airport}&dest0={data.arrival_airport}&departureDate0={data.departure_date}&lang=en-US&tripType=O&ADT={data.passengers}&YTH=0&CHD=0&INF=0&INS=0&marketCode=INT",
  as: "https://www.alaskaair.com/search/results?O={data.departure_airport}&D={data.arrival_airport}&OD={data.departure_date}&A={data.passengers}&C=0&L=0&RT=false&ShoppingMethod=onlineaward",
  am: "https://apibpamr.aeromexicorewards.com/cp/searchflights",
  av: "https://www.lifemiles.com/",
  b6: "https://www.jetblue.com/booking/flights?from={data.departure_airport}&to={data.arrival_airport}&depart={data.departure_date}&isMultiCity=false&noOfRoute=1&lang=en&adults={data.passengers}&children=0&infants=0&sharedMarket=false&roundTripFaresFlag=false&usePoints=true",
  dl: "https://www.delta.com/",
  ey: "https://digital.etihad.com/book/search?LANGUAGE=EN&CHANNEL=MOBILEWEB&B_LOCATION={data.departure_airport}&E_LOCATION={data.arrival_airport}&TRIP_TYPE=O&CABIN=E&TRAVELERS=ADT&TRIP_FLOW_TYPE=AVAILABILITY&DATE_1={data.departure_date}0000&WDS_ENABLE_MILES_TOGGLE=TRUE&FLOW=AWARD",
  ek: "https://fly2.emirates.com/CAB/IBE/SearchAvailability.aspx",
  f9: "https://booking.flyfrontier.com/Flight/InternalSelect?o1={data.departure_airport}&d1={data.arrival_airport}&dd1={data.departure_date}&ADT={data.passengers}&loy=true&promo=",
  kl: "https://www.klm.com/search/offers?activeConnection=0&bookingFlow=REWARD&cabinClass={data.cabin}&pax={data.adult}:0:{data.children}:0:0:0:0:0&connections={data.departure_airport}:A:{data.departure_date}%3E{data.arrival_airport}:A",
  qf: "https://www.qantas.com",
  sk: "https://www.flysas.com/en/book/flights/?search=OW_{data.departure_airport}-{data.arrival_airport}-{data.departure_date}_a{data.adult}c{data.children}i0y0&view=upsell&bookingFlow=points&cepId=&sortBy=rec&filterBy=all",
  tp: "https://booking.flytap.com/booking",
  ua: "https://www.united.com/en/us/fsr/choose-flights?f={data.departure_airport}&t={data.arrival_airport}&d={data.departure_date}&tt=1&at=1&sc=7&px={data.passengers}%2C0%2C0%2C0%2C0%2C0%2C0%2C0&taxng=1&newHP=True&clm=7&st=bestmatches&tqp=A",
  va: "https://book.virginaustralia.com/dx/VADX/#/flight-selection?journeyType=one-way&activeMonth={data.departure_date}&awardBooking=true&class=First&ADT={data.passengers}&CHD=0&INF=0&origin={data.departure_airport}&destination={data.arrival_airport}&date={data.departure_date}&promoCode=",
  vs: "https://www.virginatlantic.com/",
  cm: "https://shopping.copaair.com/miles?roundtrip=false&adults={data.passengers}&children=0&infants=0&date1={data.departure_date}&date2=null&promocode=&area1={data.departure_airport}&area2={data.arrival_airport}&advanced_air_search=false&flexible_dates_v2=false&airline_preference=",
  tk: "https://www.turkishairlines.com/en-int/miles-and-smiles/account/book-star-award-tickets/",
  ib: "https://www.iberia.com/",
  g3: "https://www.voegol.com.br/en-us/inicio",
  ad: "https://azulpelomundo.voeazul.com.br/flights",
  nk: "https://www.spirit.com/",
  ba: "https://www.britishairways.com/travel/redeem/execclub/_gf/en_gb?eId=100002&pageid=PLANREDEMPTIONJOURNEY&tab_selected=redeem&redemption_type=STD_RED&amex_redemption_type=&upgradeOutbound=true&WebApplicationID=BOD&Output=&hdnAgencyCode=&departurePoint={data.departure_airport}&destinationPoint={data.arrival_airport}&departInputDate={data.departure_date}&oneWay=true&RestrictionType=Restricted&NumberOfAdults={data.passengers}&NumberOfYoungAdults=0&NumberOfChildren=0&NumberOfInfants=0&aviosapp=true&CabinCode=M",
  sq: "https://www.singaporeair.com/en_UK/us/ppsclub-krisflyer/",
  cx: "https://www.cathaypacific.com/cx/en_HK/membership/my-account/miles-and-points/manage-miles/top-up-asia-miles.html",
  lh: "https://www.miles-and-more.com/row/en/spend/flights.html?adults={data.passengers}&bookingclass=E&children=0&dateformat=MM%2Fdd%2Fyyyy&destinationcode={data.arrival_airport}&infants=0&l=GB&origincode={data.departure_airport}&outbounddate={data.departure_date}&travellertype=M&triptype=OW&youths=0"
};

export const PROGRAM_CASH_LINK: NameMap = {
  aa: "https://www.aa.com/booking/search?locale=en_US&pax={data.passengers}&adult={data.passengers}&type=OneWay&searchType=Revenue&cabin=&carriers=ALL&slices=%5B%7B%22orig%22:%22{data.departure_airport}%22,%22origNearby%22:false,%22dest%22:%22{data.arrival_airport}%22,%22destNearby%22:false,%22date%22:%22{data.departure_date}%22%7D%5D&maxAwardSegmentAllowed=4",
  ua: "https://www.united.com/en/us/fsr/choose-flights?f={data.departure_airport}&t={data.arrival_airport}&d={data.departure_date}&tt=1&sc=7&px={data.passengers}&taxng=1&newHP=True&clm=7&st=bestmatches&tqp=R",
  as: "https://www.alaskaair.com/search/results?O={data.departure_airport}&D={data.arrival_airport}&OD={data.departure_date}&A={data.passengers}&C=0&L=0&RT=false",
  b6: "https://www.jetblue.com/booking/flights?from={data.departure_airport}&to={data.arrival_airport}&depart={data.departure_date}&isMultiCity=false&noOfRoute=1&lang=en&adults={data.passengers}&children=0&infants=0&sharedMarket=false&roundTripFaresFlag=false&usePoints=false",
  dl: "https://www.delta.com/",
  kl: "https://www.klm.com/search/offers?activeConnection=0&bookingFlow=LEISURE&cabinClass={data.cabin}&pax={data.adult}:0:{data.children}:0:0:0:0:0&connections={data.departure_airport}:A:{data.departure_date}%3E{data.arrival_airport}:A",
  vs: "https://www.virginatlantic.com/",
  tk: "https://www.turkishairlines.com/en-in",
};

export const ROUTE_LOYALTY_PROGRAM = Array.from(ROUTE_PROGRAM_NAME_MAP.values()).sort();
export const LOYALTY_PROGRAM = Array.from(PROGRAM_NAME_MAP.values()).sort();
export const SHOW_LOYALTY_PROGRAM = Array.from(SHOW_PROGRAM_NAME_MAP.values()).sort();
export const SHOW_PANORAMA_PROGRAM = Array.from(SHOW_PANORAMA_PROGRAM_NAME_MAP.values()).sort();

export const SUPPORTED_SEARCH_PROGRAMS = [
  ["AA", "American Airlines AAdvantage"],
  ["AC", "Air Canada Aeroplan"],
  ["AM", "Aeromexico Club Premier"],
  ["AS", "Alaska Airlines Mileage Plan"],
  ["AV", "Avianca LifeMiles"],
  ["B6", "JetBlue True Blue"],
  ["BA", "British Airways Executive Club"],
  ["CX", "Cathay Pacific Asia Miles"],
  ["CM", "Copa ConnectMiles"],
  ["G3", "GOL Smiles"],
  // ["AD", "Azul TudoAzul"],
  ["DL", "Delta SkyMiles"],
  ["EK", "Emirates Skywards"],
  ["EY", "Etihad Guest"],
  ["IB", "Iberia Avios"],
  ["KL", "Air France/KLM Flying Blue"],
  ["NK", "Spirit"],
  ["QF", "Qantas Frequent Flyer"],
  ["SQ", "Singapore KrisFlyer"],
  ["SK", "SAS EuroBonus"],
  ["TP", "TAP Air Portugal Miles&Go"],
  ["TK", "Turkish Miles & Smiles"],
  ["UA", "United MileagePlus"],
  ["VA", "Virgin Australia Velocity"],
  ["VS", "Virgin Atlantic Flying Club"],
];

export const supportedSearchPrograms = SUPPORTED_SEARCH_PROGRAMS.map((value) => {
  return {
    value: value[0],
    name: value[0],
    fullname: value[1],
  };
});

// Sort by name
export const searchProgramsOptions = supportedSearchPrograms.sort((a, b) => {
  return a.name.localeCompare(b.fullname);
});
